import { motion } from "framer-motion";
import { ArrowUpRight, Mail } from "lucide-react";
import { WHATSAPP_URL, EMAIL } from "../data/services";

export const CtaSection = () => {
    return (
        <section className="py-28 md:py-40 bg-coral text-navy overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="font-mono text-xs uppercase tracking-[0.3em] mb-6"
                >
                    Sin formularios. Sin esperas.
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="font-display font-black tracking-tighter leading-[0.95] text-[14vw] md:text-[8vw]"
                >
                    ¿Empezamos<span className="italic font-medium">?</span>
                </motion.h2>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-12 flex flex-wrap items-center gap-6"
                >
                    <a
                        data-testid="cta-whatsapp-btn"
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center gap-3 bg-navy text-cream px-10 py-5 font-mono text-sm uppercase tracking-[0.15em] font-semibold hover:gap-5 transition-all duration-300"
                    >
                        Escríbenos por WhatsApp
                        <ArrowUpRight size={18} className="text-coral" />
                    </a>
                    <a
                        data-testid="cta-email-link"
                        href={`mailto:${EMAIL}`}
                        className="flex items-center gap-2 font-mono text-sm underline underline-offset-4 hover:text-cream transition-colors duration-300"
                    >
                        <Mail size={16} />
                        {EMAIL}
                    </a>
                </motion.div>
            </div>
        </section>
    );
};
